import { Fragment } from "react";
import { Avatar } from "primereact/avatar";

import { Card, CardBody } from "reactstrap";

import driver from "assets/images/driver.png";

import Breadcrumbs from "Components/Breadcrumbs";

import { CREATE_DRIVER, EDIT_DRIVER, MY_DRIVERS } from "Constant";

import { API, COLUMNS, CREATE_TAXI_DRIVER } from "./data";

// import SimpleDataTable from "Components/DataTables/SimpleDataTable";
import ModalApp from "Components/ModalApp";
import AddItem from "Components/AddItemWithZod";
import EditItem from "Components/EditItemWithZod";
import UploadAvatar from "Components/UploadDoc/UploadAvatar";

import { gridItem, listItem } from "./CardUser";
import DateView from "Components/DateView";
import LeftToolBar from "./LeftToolBar";

//import DriverForm from "Components/Forms/Driver/DriverForm";

const UsersPage = () => {
  const breadCrumbsProps = [MY_DRIVERS];

  const { list } = API;

  const getOldData = (data) => {
    try {
      const driverData = data.data.results.data;
      console.log("=== Debug EditDriver ===");
      console.log("Driver data complet:", driverData);
      
      // Vérifier les deux possibilités de nom de champ
      const inAllTaxiValue = driverData.in_all_taxi || driverData.inAllTaxi || false;
      console.log("Valeur trouvée pour inAllTaxi:", inAllTaxiValue);
      
      // Afficher toutes les clés de l'objet pour voir le nom exact
      console.log("Toutes les clés de driverData:", Object.keys(driverData));
      
      const res = {
        ...driverData,
        inAllTaxi: inAllTaxiValue,
        taxi: driverData.taxi?.code ?? null
      };
      
      console.log("Données finales:", res);
      console.log("=== Fin Debug ===");
      
      return res;
    } catch (error) {
      console.error("Error in getOldData:", error);
      console.error("Stack trace:", error.stack);
      return [];
    }
  };

  return (
    <Fragment>
      <Card>
        <CardBody>
          <Breadcrumbs breadCrumbsProps={breadCrumbsProps} />

          <DateView
            LeftToolBar={LeftToolBar}
            link={list}
            gridItem={gridItem}
            listItem={listItem}
          />
        </CardBody>
      </Card>

      <ModalApp type="editUser" title={EDIT_DRIVER}>
        <EditItem itemsUpdate={CREATE_TAXI_DRIVER} getOldData={getOldData} />
      </ModalApp>

      <ModalApp size="lg" type="editUserImg" title={EDIT_DRIVER}>
        {/* <EditItem itemsUpdate={CREATE_TAXI_DRIVER} /> */}
        <UploadAvatar fileName="proof" />
      </ModalApp>

      <ModalApp type="createDriver" title={CREATE_DRIVER} size="xl">
       <AddItem addURL={API.create} items={CREATE_TAXI_DRIVER} />
      {/* <DriverForm addURL={API.create} items={CREATE_TAXI_DRIVER} /> */}
        {/* <CreateDriver /> */}
      </ModalApp>
    </Fragment>
  );
};

export default UsersPage;
